import React from "react";
import "./index.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CaseCardList from "../../components/PostsList/components/CaseCardList";
import PostsList from "../../components/PostsList";
import { searchPosts, clearSearchPosts } from "../../actions/searchActions";
import { selectIsSSRUser } from "../../util/selectors";

export class Search extends React.Component {
  constructor(props) {
    super(props);
    this.searchPostsAction = this.searchPostsAction.bind(this);
  }

  componentDidMount() {
    // If the page is server-side rendered,
    // refetch the posts after authentication is done
    // This updates the interactions state and dropdown menu if the user is logged-in
    this.props.isSSRUser && this.searchPostsAction({ override: true });
  }

  componentDidUpdate(nextProps) {
    if (nextProps.URLQuery.search_query !== this.props.URLQuery.search_query) {
      this.props.clearSearchPostsAction();
    }
  }

  componentWillUnmount() {
    this.props.clearSearchPostsAction();
  }

  render() {
    const searchQuery = this.props.URLQuery.search_query;
    const { data: posts, hasMore } = this.props.foundPosts;
    const shouldEndOfResultsRender = !hasMore && posts.length > 0;
    return (
      <div className={"search-page"}>
        {posts.length > 0 && <h4 className="found-results">found results for "{searchQuery}" </h4>}

        <PostsList
          posts={this.props.foundPosts}
          loadMorePosts={this.searchPostsAction}
          NotFoundComponent={<h5 className="center-text">There are no results for "{searchQuery}".</h5>}
          CaseListComponent={CaseCardList}
        />

        {shouldEndOfResultsRender && <div className="center-text">End of results.</div>}
      </div>
    );
  }

  searchPostsAction(options) {
    const { URLQuery: { search_query: searchQuery } } = this.props;
    this.props.searchPostsAction({ searchQuery, ...options });
  }
}

Search.propTypes = {
  foundPosts: PropTypes.array.isRequired,
  URLQuery: PropTypes.object.isRequired,
  searchPostsAction: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    foundPosts: state.search.foundPosts,
    URLQuery: state.router.query,
    isSSRUser: selectIsSSRUser(state),
  };
};

function mapDispatchToProps(dispatch) {
  return {
    clearSearchPostsAction: () => {
      dispatch(clearSearchPosts());
    },
    searchPostsAction: (...props) => dispatch(searchPosts(...props)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);



// WEBPACK FOOTER //
// ./src/scenes/Search/index.js